import React, { useState } from 'react';
import axios from 'axios';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleForgotPassword = (e) => {
    e.preventDefault();
    axios.post('https://api.finaloffers.fyi/auth/forgot-password', { email })
      .then(response => {
        setMessage(response.data.message);
      })
      .catch(error => {
        setMessage(error.response.data.message);
      });
  };

  return (
    <div className='flex justify-center items-center mt-10'>
      <div className='border border-black rounded shadow-solid h-96'>
      <div className='justify-center text-center w-80 mt-16 font-bold text-lg px-8'>Enter your email to reset password</div>
        <form className='w-96 max-w-xs p-5 mt-5 rounded' onSubmit={handleForgotPassword}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className='items-center w-full rounded h-8 text-sm focus:ring-0 border-black focus:border-black'
          />
          <button className="items-center w-full bg-black text-white rounded mt-12 h-8 text-sm cursor-pointer" type="submit">Reset Password</button>
          {message && <p className='justify-center text-center text-sm mt-4'>{message}&nbsp;&nbsp;<a href="/signup" className='text-blue-600 underline'>Create account?</a></p>}
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
